import { render, staticRenderFns } from "./RankingCourse.vue?vue&type=template&id=bd309d92&scoped=true"
import script from "./RankingCourse.vue?vue&type=script&lang=js"
export * from "./RankingCourse.vue?vue&type=script&lang=js"
import style0 from "./RankingCourse.vue?vue&type=style&index=0&id=bd309d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd309d92",
  null
  
)

export default component.exports